<template>
	<bernstein-layout>
		<!-- test -->
		<!-- {{ params }} -->
		<!-- {{ dsvs }} -->
		<div v-if="form.orderIds.length">
			<p class="font-bold text-gray-800">Gewählte Aufträge</p>
			<p v-for="(orderId, oIdx) in form.orderIds">
				<span class="px-1"> {{ orderId }} </span>
				<span v-if="oIdx != form.orderIds.length - 1">,</span>
			</p>
		</div>
		<!-- {{ form.orderIds }} -->
		<!-- <div v-for="dsv in dsvs">{{ dsv.plenty_id }}</div> -->
		<div clas="max-w-md  rounded ">
			<div class="m-auto">
				<jet-validation-errors class="mx-auto mb-4 text-center" />
			</div>
			<div class="mx-auto rounded-lg bg-blue-300 md:w-96">
				<form @submit.prevent="submit" class="mt-2 text-center">
					<button
						type="submit"
						class="w-full rounded-lg py-4 font-bold text-gray-900 md:p-4"
					>
						{{ form.action.toUpperCase() }}
					</button>
				</form>
			</div>
			<!-- <submit-form
				:orderId="this.getOrdreIds"
				action="Versandliste"
				class="max-w-md"
			>
			</submit-form> -->
		</div>
		<div class="flex flex-row justify-between py-2">
			<Link
				v-if="dsvs.prev_page_url"
				class="m-2 rounded bg-gray-300 px-4 py-2 font-bold"
				:href="dsvs.prev_page_url"
				>Previous Page
			</Link>
			<div class="px-2 py-2 text-lg font-bold text-gray-800">Order Items</div>
			<Link
				v-if="dsvs.next_page_url"
				class="m-2 rounded bg-gray-300 px-4 py-2 font-bold"
				:href="dsvs.next_page_url"
				>Next Page
			</Link>
		</div>

		<Table
			:filters="queryBuilderProps.filters"
			:search="queryBuilderProps.search"
			:columns="queryBuilderProps.columns"
			:on-update="setQueryBuilder"
			:meta="dsvs"
			class="relative w-full border"
		>
			<!-- Table head  -->
			<template #head>
				<tr
					class="sticky border-b border-gray-400 bg-gray-300 py-2 font-bold text-gray-900"
				>
					<!-- Verand Button -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('versenden')"
					>
						Auftrag wählen
					</th>
					<!-- Druck Button -->
					<!-- <th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('drucken')"
					>
						Drucken
					</th> -->
					<!-- order Id  -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('orderId')"
						@click.prevent="sortBy('orderId')"
					>
						<span class="flex flex-row space-x-2">
							<span> Order Id</span>
							<svg
								v-if="params.sort == 'orderId'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-orderId'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>

					<!--orderItem ids -->
					<!-- @click.prevent="sortBy('itemVariationId')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('orderitemIds')"
					>
						Orderitem Ids
					</th>

					<!-- Order item name   -->
					<!-- @click.prevent="sortBy('orderItemName')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('sendingNumber')"
					>
						Label
					</th>

					<!-- billNo -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('billNo')"
						@click.prevent="sortBy('billNo')"
					>
						<!-- Bill No arrow for up and down  -->
						<span class="flex flex-row space-x-2">
							<span class="px-2">Bill No </span>
							<!-- upward sorting -->
							<svg
								v-if="params.sort == 'billNo'"
								class="h-8 w-8 text-red-500"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" />
								<line x1="4" y1="6" x2="11" y2="6" />
								<line x1="4" y1="12" x2="11" y2="12" />
								<line x1="4" y1="18" x2="13" y2="18" />
								<polyline points="15 9 18 6 21 9" />
								<line x1="18" y1="6" x2="18" y2="18" />
							</svg>

							<!-- from up to down icon  -->
							<svg
								v-if="params.sort == '-billNo'"
								class="h-8 w-8 text-red-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"
								/>
							</svg>
						</span>
					</th>

					<!-- paymentType -->
					<!-- @click.prevent="sortBy('order.paymentType')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('paymentType')"
					>
						Payment Type
					</th>

					<!-- deleveryCountry -->
					<!-- @click.prevent="sortBy('order.deleveryCountry')" -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('deleveryCountry')"
					>
						Delevery Country
					</th>
				</tr>
				<!-- <tr><th class="fixed top-0"> test</th> </tr>      -->
			</template>
			<!--
       ******
       * 
       * here starts the table body  
       *
       -->
			<template #body>
				<tr
					v-for="(dsv, dsvIndex) in dsvs.data"
					:key="dsvIndex"
					:class="[{ 'bg-gray-100': dsvIndex % 2 == 0 }, p - 1]"
				>
					<!-- deleveryCountry -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('versenden')"
					>
						<input
							type="checkbox"
							:id="dsv.orderId"
							:value="dsv.orderId"
							v-model="form.orderIds"
							class="rounded-sm border-gray-800 p-4"
						/>
						<!-- <label></label> -->
						<!-- <submit-form :orderId="dsv.orderId" action="send_dsv_message">
						</submit-form> -->
					</td>
					<!-- Drucken -->
					<!-- <td class="border-r border-green-200" v-show="showColumn('drucken')">
						<submit-form :orderId="dsv.orderId" action="drucken"> </submit-form>
					</td> -->

					<!-- order Id  -->
					<td class="border-r border-green-200" v-show="showColumn('orderId')">
						{{ dsv.orderId }}
					</td>

					<!-- order item name  -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('orderitemIds')"
					>
						<div
							v-for="orderItem in JSON.parse(dsv.orderitemIds)"
							class="mx-auto"
						>
							<diV class="my-1 w-full px-2">
								<!-- {{ orderItem }} -->
								<button
									@click="openModal(dsv.orderId, orderItem)"
									class="my-1 rounded-lg bg-blue-300 px-8 py-4 font-bold text-gray-800"
								>
									{{ orderItem }}
								</button>
								<!-- <submit-form :orderId="dsv.orderId" :action="orderItem">
								</submit-form> -->
							</diV>
						</div>
					</td>
					<!-- itemVariationId  -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('sendingNumber')"
					>
						<!-- {{ JSON.parse(dsv.sendingNumber)[1] }} -->
						<div
							v-for="(shippingNr, shipIndx) in JSON.parse(dsv.sendingNumber)"
						>
							<p
								class="my-2 mx-auto w-full rounded-lg bg-blue-300 py-4"
								v-if="shipIndx != 0"
							>
								<!-- href="/storage/dsv/label/1664959622_6307231325494003_label.pdf" -->

								<a
									:href="getlabelName(dsv.labelFileName, shipIndx)"
									class="m-auto rounded px-2 py-4 text-center text-justify font-bold"
								>
									{{ shippingNr }}
								</a>
							</p>
						</div>
					</td>

					<!-- billNo  -->
					<td class="border-r border-green-200" v-show="showColumn('billNo')">
						{{ dsv.order.billNo }}
					</td>

					<!-- paymentType -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('paymentType')"
					>
						{{ dsv.order.paymentType }}
					</td>

					<!-- deleveryCountry -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('deleveryCountry')"
					>
						{{ dsv.order.deleveryCountry }}
					</td>
					<!-- return reason  -->
				</tr>
			</template>
			<!-- Table head ends here  -->
		</Table>
		<!-- here starts the modal  -->
		<TransitionRoot appear :show="isOpen" as="template">
			<Dialog as="div" @close="closeModal">
				<div class="fixed inset-0 z-10 overflow-y-auto">
					<div class="min-h-screen px-4 text-center">
						<TransitionChild
							as="template"
							enter="duration-300 ease-out"
							enter-from="opacity-0"
							enter-to="opacity-100"
							leave="duration-200 ease-in"
							leave-from="opacity-100"
							leave-to="opacity-0"
						>
							<DialogOverlay class="fixed inset-0" />
						</TransitionChild>

						<span class="inline-block h-screen align-middle" aria-hidden="true">
							&#8203;
						</span>

						<TransitionChild
							as="template"
							enter="duration-300 ease-out"
							enter-from="opacity-0 scale-95"
							enter-to="opacity-100 scale-100"
							leave="duration-200 ease-in"
							leave-from="opacity-100 scale-100"
							leave-to="opacity-0 scale-95"
						>
							<div
								class="my-8 inline-block w-full max-w-md transform overflow-hidden rounded-2xl bg-gray-50 bg-white p-6 text-left align-middle shadow-xl transition-all"
							>
								<div class="mr-0 text-right">
									<button
										type="button"
										class="justify-right inline-flex rounded-lg border border-transparent bg-blue-100 p-1 text-3xl font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
										@click="closeModal"
									>
										X
									</button>
								</div>
								<DialogTitle
									as="h3"
									class="mb-2 text-center text-lg font-bold leading-6 text-gray-900"
								>
									Eingabe Formular für <br />Auftrag:{{ cur_orderId }}, Artikel:
									{{ cur_orderItemId }}
								</DialogTitle>
								<!-- <img :src="picUrl" class="h-full w-full object-cover" /> -->
								<!-- form starts here  -->
								<itemform
									class="w-full max-w-sm py-2"
									@submit.prevent="orderitemSubmit"
								>
									<div class="mb-6 md:flex md:items-center">
										<div class="md:w-1/3">
											<label
												class="mb-1 block pr-4 font-bold text-gray-500 md:mb-0 md:text-right"
												for="inline-full-name"
											>
												Länge
											</label>
										</div>
										<div class="md:w-2/3">
											<input
												class="w-full appearance-none rounded border-2 border-gray-200 bg-gray-200 py-2 px-4 leading-tight text-gray-700 focus:border-purple-500 focus:bg-white focus:outline-none"
												id="inline-full-name"
												type="text"
												v-model="itemform.length"
											/>
										</div>
									</div>
									<!-- Breite  -->
									<div class="mb-6 md:flex md:items-center">
										<div class="md:w-1/3">
											<label
												class="mb-1 block pr-4 font-bold text-gray-500 md:mb-0 md:text-right"
												for="inline-full-name"
											>
												Breite
											</label>
										</div>
										<div class="md:w-2/3">
											<input
												class="w-full appearance-none rounded border-2 border-gray-200 bg-gray-200 py-2 px-4 leading-tight text-gray-700 focus:border-purple-500 focus:bg-white focus:outline-none"
												id="inline-full-name"
												type="text"
												v-model="itemform.breadth"
											/>
										</div>
									</div>
									<!-- Gewicht  -->
									<div class="mb-6 md:flex md:items-center">
										<div class="md:w-1/3">
											<label
												class="mb-1 block pr-4 font-bold text-gray-500 md:mb-0 md:text-right"
												for="inline-full-name"
											>
												Gewicht
											</label>
										</div>
										<div class="md:w-2/3">
											<input
												class="w-full appearance-none rounded border-2 border-gray-200 bg-gray-200 py-2 px-4 leading-tight text-gray-700 focus:border-purple-500 focus:bg-white focus:outline-none"
												id="inline-full-name"
												type="text"
												v-model="itemform.weight"
											/>
										</div>
									</div>
									<!-- Submit  -->
									<div class="flex flex-row md:items-center">
										<div class="mt-4 w-1/3 text-left"></div>
										<div class="mt-4 w-2/3">
											<button
												class="focus:shadow-outline rounded bg-blue-500 py-2 px-4 font-bold text-white shadow hover:bg-purple-400 focus:outline-none"
												type="button"
												@click="orderitemSubmit"
											>
												Submit
											</button>
										</div>
									</div>
								</itemform>
								<!-- form ends here  -->

								<!-- <div class="mt-4 mr-0 text-right">
									<button
										type="button"
										class="justify-right inline-flex rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
										@click="closeModal"
									>
										Schließen
									</button>
								</div> -->
							</div>
						</TransitionChild>
					</div>
				</div>
			</Dialog>
		</TransitionRoot>
		<!-- here ends the modal  -->
	</bernstein-layout>
</template>
<script>
// import JetInput from "@/Jetstream/Input";
import { useForm } from "@inertiajs/inertia-vue3";
import JetValidationErrors from "@/Jetstream/ValidationErrors";
import { Head, Link } from "@inertiajs/inertia-vue3";
import BernsteinLayout from "@/Layouts/BernsteinLayout.vue";
import SubmitForm from "@/Pages/Versand/Dsv/SubmitForm";

import {
	InteractsWithQueryBuilder,
	Tailwind2,
} from "@protonemedia/inertiajs-tables-laravel-query-builder";
import {
	TransitionRoot,
	TransitionChild,
	Dialog,
	DialogOverlay,
	DialogTitle,
} from "@headlessui/vue";
import { defineComponent, ref } from "vue";
// import Counter from "./Counter.vue";
export default defineComponent({
	mixins: [InteractsWithQueryBuilder],
	components: {
		BernsteinLayout,
		Head,
		Link,
		Table: Tailwind2.Table,
		// Modal components
		TransitionRoot,
		TransitionChild,
		Dialog,
		DialogOverlay,
		DialogTitle,
		//
		SubmitForm,
		JetValidationErrors,
	},
	props: {
		params: Array,
		dsvs: Array,
	},

	data() {
		return {
			orderIds: [],
		};
	},

	methods: {
		getlabelName(labelNames, dsvIndex) {
			// console.log(dsv[0]);
			labelNames = JSON.parse(labelNames);
			return labelNames[dsvIndex];
		},
	},
	setup() {
		const isOpen = ref(false);
		const cur_orderId = ref("");
		const cur_orderItemId = ref("");
		//
		const form = useForm({
			orderIds: [],
			action: "Nachricht an DSV SENDEN",
		});
		// this.$inertia.post(route('candidacy.store'), data);
		function submit() {
			// console.log(this.voting_code);
			form.post("/dsv/send");
		}
		const itemform = useForm({
			length: "",
			breadth: "",
			weight: "",
			itemVariationId: "",
			orderId: "",
		});
		function orderitemSubmit() {
			console.log("length: " + itemform.length);
			if (itemform.length == "") {
				alert("Bitte Länge eingeben!");
				return;
			}
			if (itemform.breadth == "") {
				alert("Bitte Breite eingeben!");
				return;
			}
			if (itemform.weight == "") {
				alert("Bitte Gewicht eingeben!");
				return;
			}
			itemform.post("/dsv/orderitem/send");
			this.closeModal();
			return;
		}
		return {
			isOpen,
			cur_orderId,
			cur_orderItemId,
			itemform,
			orderitemSubmit,
			closeModal() {
				isOpen.value = false;
			},
			openModal(orderId, itemVariationId) {
				isOpen.value = true;
				cur_orderId.value = orderId;
				cur_orderItemId.value = itemVariationId;
				itemform.orderId = orderId;
				itemform.itemVariationId = itemVariationId;
				// console.log(cur_orderId);
				// console.log(cur_orderItemId);

				// console.log(image.url);
				// if (image.url != "") {
				// 	picUrl.value = image.url;
				// }
				// console.log(picUrl);
			},
			form,
			submit,
		};
	},
});
</script>
